site.megamenu = {
	init:function() {
		site.megamenu.background();

		var $mainmenu = $('#mainmenu'),
			$body = $('body');
		$('li:not(.noMega) .mmLevel2', $mainmenu).wrap('<div class="megamenu"><div class="wrap"><div class="contentWrap" /></div></div>');
		$mainmenu.on('click', function(e) {
			e.stopPropagation();
		});

		$('.level1.children:not(.noMega) > a',$mainmenu).on('click', function (e) {
			if ($(document).width() >= 992) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					$('.level1.open', $mainmenu).removeClass('open');
					$('.megamenu', $mainmenu).removeAttr('style');
					$(this).parent().addClass('open');
					site.megamenu.setHeight();

					if (!$body.hasClass('megamenu-open')) {
						$body.addClass('megamenu-opening');
						setTimeout(function() {
							$body.removeClass('megamenu-opening');
							if (!$body.is('.megamenu-closing')) {
								$body.addClass('megamenu-open');
							}
						},600);
					}
				}
			}
		});

		$body.on('click', function (e) {
			if ($body.hasClass('megamenu-open')) {
				site.megamenu.close();
			}
		});

		$(window).resize(function() {
			site.megamenu.setHeight();
		});
	},

	setHeight:function() {
		var $megamenu = $('.megamenu', '#mainmenu .level1.open');
		if ($megamenu.length > 0) {
			var $megamenuHeight = $('.megamenu .contentWrap', '#mainmenu .level1.open')[0].scrollHeight + 95;
			$('.megamenu', '#mainmenu').css('max-height', $megamenuHeight);
			$('#contentContainer').css('min-height', $megamenuHeight);
			$('#megamenuBg').css('height', $megamenuHeight);
		}
	},

	close:function() {
		var $body = $('body'),
			$mainmenu = $('#mainmenu');
		$('.megamenu', $mainmenu).removeAttr('style');
		$('#contentContainer').removeAttr('style');

		if ($body.hasClass('megamenu-open') || $body.hasClass('megamenu-opening')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
				$('.level1.open', $mainmenu).removeClass('open');
			},600);
		}
		$body.removeClass('megamenu-open');
	},

	background:function() {
		 var $header = $('header');
		 $header.append('<div id="megamenuBg" />');

		 $('#megamenuBg').on('click touchstart', function(e) {
			 e.stopPropagation();
		 });
	}
};
